<template>
    
    <div id="st-map-container">
        
        <GeoMap 
            :areaData="areaData"
            :nodeData="nodeData"
            :platformData="platformData"
            :axisData="kernelData"
            :enterpriseData="enterpriseData"
            :nanshaData="nanshaData"
        />
        <div class="music">
            <img id="imgId" @click="switchPlayState" :src="isPlay ? playUrl : pauseUrl" alt="">
            <audio id="audio" preload="preload" :src="musicUrl" loop></audio>
        </div>
        <div v-show="(tOption.type == 1 || tOption.type == 3) &&  showZoon == true" 
        :style="{position: 'absolute',
            left: zoneData.x + 'px',
            top: zoneData.y + 70 + 'px',
            'z-index': 1,
            'min-width': '8rem',
            cursor: 'pointer',
            transition: 'all 1.5s'}">
            <div class="area-title">
                {{ zoneData.name }}
            </div>
            <div class="area-desc">
                {{ zoneData.desc }}
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState, mapMutations } from "vuex";

    import GeoMap from "@/components/GeoMap";
    import play from "@/assets/images/search/play.png";
    import pause from "@/assets/images/search/pause.png";

    export default {
        name: "STMap",
        components: {
            GeoMap
        },
        data() {
            return {
                areaData: [],
                nodeData: [],
                platformData: [],
                enterpriseData: [],
                kernelData: [],
                nanshaData: [],
                index: 2,
                playUrl: play,
                pauseUrl: pause,
                musicUrl: 'https://img.21jingji.com//uploadfile/cover/20220621/bede728e6f31b517e3ce22a7e8b81618.mp3',
                isPlay: true,
                isShow: false
            }
        },
        computed: {
            ...mapState([ "tData","tOption", "bTableData", "zoneData","showZoon"])
        },
        mounted() {
            this.playMusic()
            // document.getElementById('imgId').click()
            // this.switchPlayState()
        },
        methods: {
            ...mapMutations(["updateTOption"]),
            playMusic() {
                // console.log(this.isPlay,'====');
                this.$nextTick(() => {
                    document.getElementById('audio').play();
                })
            },
            switchPlayState() {
                this.isPlay = !this.isPlay;
                // console.log(this.isPlay, '==========================');
                if(this.isPlay) {
                    document.getElementById('audio').play();
                }else {
                    document.getElementById('audio').pause();
                }
            },
            generateAreaData(area) {

                const that = this;

                this.areaData = area.map(element => {

                    const { value } = element;

                    return {
                        ...element,
                        path: value.map(e => {
                            return that.$mapUtils.getPointBMap(e);
                        })
                    };
                });
                // console.log(this.areaData, '===9999123');
            },
            generatePointData(data) {

                const that = this;

                return data.map(element => {

                    const { value } = element;

                    return {
                        ...element,
                        coord: that.$mapUtils.getPointBMap(value)
                    }
                });
            },
            generateNodeData(node) {
                this.nodeData = this.generatePointData(node);
            },
            generatePlatformData(platform) {
                this.platformData = this.generatePointData(platform);
            },
            generateEnterpriseData(enterprise) {

                this.enterpriseData = enterprise.filter(element => element.coordinate).map(element => {

                    const { coordinate, category } = element;

                    const [ lat, lng ] = coordinate.split(",");

                    return {
                        ...element,
                        coord: [parseFloat(lat), parseFloat(lng)],
                        styleId: category.includes("专精特新企业库")? "style2" : "style1"
                    };
                });
            },
            generateNanShaData(nansha) {
               const that = this;

                this.nanshaData = nansha.map(element => {

                    const { value } = element;

                    return {
                        ...element,
                        path: value.map(e => {
                            return that.$mapUtils.getPointBMap(e);
                        })
                    };
                });
            },
            changeArea() {
                this.index++
                if(this.index >= this.areaData.length) {
                    this.index = 0
                }
            }
        },
        watch: {
            tData: {
                immediate: true,
                deep: true,
                handler(val) {

                    if (!val) {
                        return;
                    }
                    const { area, node, platform, kernel, nansha } = this.tData;

                    if (nansha) {
                        this.generateNanShaData(nansha);
                    }

                    if (area) {
                        // console.log(area, '00000');
                        this.generateAreaData(area);

                    }

                    if (node) {
                        this.generateNodeData(node);
                        // console.log(this.nodeData, '===========');
                    }

                    if (platform) {
                        this.generatePlatformData(platform);
                    }

                    if (kernel) {
                        this.kernelData = this.generatePointData([ kernel ] );
                    }
                }
            },
            bTableData: {
                immediate: true,
                deep: true,
                handler(val) {

                    if (!val) {
                        return;
                    }

                    this.generateEnterpriseData(val);
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .area-title {
        background-color: rgb(30, 71, 126);
        color: rgb(110, 248, 160);
        border-radius: 0rem 0rem 3rem 0rem;
        padding-left: 0.5rem;
    }
    .area-desc {
        color: #fff;
        padding: 0.5rem;
        margin-top: 0.5rem;
        font-size: 12px;
        letter-spacing: 0.1rem;
        width: inherit;
        max-width: 8rem;
        word-wrap: break-word !important;
        white-space: normal !important;
        word-break: break-all !important;
        background: rgb(0, 18, 100);
    }
    .music {
        position: absolute;
        top: 0;
        right: 0.6rem;
        img{
            width: 4rem;
        }
    }
</style>

